import { useDispatch } from "react-redux";
import styles from "./index.module.css";
import { setNotes } from "../../../store/slices/popup/popup.slice";

const NotesPopup = (props)=>{
    const dispatch = useDispatch();

    const closePopup = ()=>{
        dispatch(setNotes({showNotes:false, notes:""}));
    }    

    return <div className={styles["container"]}>
        <div className={styles["content"]}>
            <div className={styles["notes"]}>
                {props?.notes}
            </div>
            <div className={styles["cta"]}>
                <div className={styles["button"]} onClick={closePopup}>
                    DONE
                </div>
            </div>
        </div>
    </div>
}

export default NotesPopup;